import { Trans, useTranslation } from "react-i18next";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * Names the remedy rather than the mailbox: since #33 this is the ordinary outcome for every
 * jeugdleider who is not their korps's contact (docs/adr/0004-authorisation-model.md). Static
 * text, because ADR-0024 keeps the beheerder claim off this door and ADR-0005 promotes one image.
 */
export function GeenKorpsKaart() {
  const { t } = useTranslation(["ploegen", "common"]);
  const mailbox = t("common:mailbox");

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("ploegen:geenKorps.title")}</CardTitle>
        <CardDescription>
          {/* The <strong> around the rol is part of the sentence, so it rides along in the
              catalog and <Trans> puts the real element back. */}
          <Trans t={t} i18nKey="ploegen:geenKorps.portaal" components={{ strong: <strong /> }} />
          <br />
          <br />
          {t("ploegen:geenKorps.regiocontactBefore")}
          <a className="jb-link" href={`mailto:${mailbox}`}>
            {mailbox}
          </a>
          {t("ploegen:geenKorps.regiocontactAfter")}
          <br />
          <br />
          {t("ploegen:geenKorps.wedstrijdleider")}
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
